import { render, staticRenderFns } from "./ModalConfirmacaoEtapas.vue?vue&type=template&id=956bddd8&lang=pug"
import script from "./ModalConfirmacaoEtapas.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacaoEtapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports